var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLapBangKe71Cb3372(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4374",
    "data-name": "Ellipse 4374",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(0 0)",
    fill: "#f5f8fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.909,
    y1: 1,
    x2: 0.294,
    y2: -0.021,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bd2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7edfe"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_22798",
    x: 8.595,
    y: 20.787,
    width: 62.743,
    height: 44.426,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#007aff",
    floodOpacity: 0.439
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_4373",
    x: -2,
    y: 24.638,
    width: 36.725,
    height: 36.725,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#66afff",
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.074,
    y1: 0.282,
    x2: 0.918,
    y2: 0.762,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8983e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffba30",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LapBangKe",
    transform: "translate(-892 -293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53141",
    "data-name": "Group 53141",
    transform: "translate(11518 5867)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4372",
    "data-name": "Ellipse 4372",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(-10626 -5574)",
    fill: "#f5f9fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    transform: "translate(-10626 -5574)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22826",
    "data-name": "Rectangle 22826",
    width: 57.84,
    height: 63.474,
    rx: 4,
    transform: "translate(12.103 21.386)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75990",
    "data-name": "Path 75990",
    d: "M1.205,12.931C6,10.875,9.73,1.408,5.018.809-.632.09.434,12.417,4.761,11.689s9.895-5.726,6.9-7.025c-3.855-1.671-3.984,6.382-1.2,6.725s3.041-3.941,4.2-3.941-.257,3.17,1.5,2.956.771-3.47,2.613-3.47",
    transform: "translate(16.881 58.44)",
    fill: "none",
    stroke: "#007aff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22827",
    "data-name": "Rectangle 22827",
    width: 28.546,
    height: 4.876,
    rx: 2.438,
    transform: "translate(14.405 30.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22828",
    "data-name": "Rectangle 22828",
    width: 15.546,
    height: 4.876,
    rx: 2.438,
    transform: "translate(14.405 37.963)",
    fill: "#fff",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53133",
    "data-name": "Group 53133",
    transform: "translate(-1.469 8.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53182",
    "data-name": "Group 53182",
    transform: "translate(19.063 18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -17.59, -26.79)",
    filter: "url(#Rectangle_22798)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22798-2",
    "data-name": "Rectangle 22798",
    width: 44.743,
    height: 26.426,
    rx: 4,
    transform: "translate(17.59 26.79)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53181",
    "data-name": "Group 53181",
    transform: "translate(1.784 2.043)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_5153",
    "data-name": "Line 5153",
    y2: 22.771,
    transform: "translate(13.183)",
    fill: "none",
    stroke: "#6bd2ff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5155",
    "data-name": "Line 5155",
    y2: 22.771,
    transform: "translate(27.565)",
    fill: "none",
    stroke: "#6bd2ff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5154",
    "data-name": "Line 5154",
    x2: 41.947,
    transform: "translate(0 7.19)",
    fill: "none",
    stroke: "#6bd2ff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_5156",
    "data-name": "Line 5156",
    x2: 41.947,
    transform: "translate(0 15.58)",
    fill: "none",
    stroke: "#6bd2ff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_53166",
    "data-name": "Group 53166",
    transform: "translate(8.469 21.851)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7, -30.64)",
    filter: "url(#Ellipse_4373)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4373-2",
    "data-name": "Ellipse 4373",
    cx: 9.362,
    cy: 9.362,
    r: 9.362,
    transform: "translate(7 30.64)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_add",
    transform: "translate(2.34 2.34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53140",
    "data-name": "Group 53140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75956",
    "data-name": "Path 75956",
    d: "M0,14.043V0H14.043V14.043",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75957",
    "data-name": "Path 75957",
    d: "M0,0H14.043V14.043H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75958",
    "data-name": "Path 75958",
    d: "M12,5v8.192",
    transform: "translate(-4.978 -2.074)",
    fill: "none",
    stroke: "#007aff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75959",
    "data-name": "Path 75959",
    d: "M5,12h8.192",
    transform: "translate(-2.074 -4.978)",
    fill: "none",
    stroke: "#007aff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Component_154_11",
    "data-name": "Component 154 \\u2013 11",
    transform: "translate(946 347)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4387",
    "data-name": "Ellipse 4387",
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#ffba30",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75998",
    "data-name": "Path 75998",
    d: "M51.414,26.118,39.61,19.5,38,31.484,46.049,35.6Z",
    transform: "translate(-25.838 -12.524)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53205",
    "data-name": "Group 53205",
    transform: "translate(6.797 6.797)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75999",
    "data-name": "Path 75999",
    d: "M29.439,19a1.431,1.431,0,0,0-1.431,1.431V23.65a.358.358,0,0,1-.358.358H24.431a1.431,1.431,0,1,0,0,2.862H27.65a.358.358,0,0,1,.358.358v3.219a1.431,1.431,0,0,0,2.862,0V27.228a.358.358,0,0,1,.358-.358h3.219a1.431,1.431,0,1,0,0-2.862H31.228a.358.358,0,0,1-.358-.358V20.431A1.431,1.431,0,0,0,29.439,19Z",
    transform: "translate(-23 -19)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapBangKe71Cb3372);
export default __webpack_public_path__ + "static/media/LapBangKe.71cb3372.ad32d31dde7e97463e2f2e7e80a8b139.svg";
export { ForwardRef as ReactComponent };